import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import { createAnimationPreviewCanvas, disposeAnimationPreviewCanvas, getAnimationPreviewCanvas } from '../../canvas/animationEditor/AnimationPreviewCanvas';
// This is a class-based component to have proper mounting/dismounting with hot reloading.
// See the comment in GameContainer.tsx for more details.
export class AnimationPreviewCanvasContainer extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "refElement", void 0);
  }

  componentDidMount() {
    createAnimationPreviewCanvas(this.props.width, this.props.height);
    getAnimationPreviewCanvas().attach(this.refElement);
  }

  componentWillUnmount() {
    disposeAnimationPreviewCanvas();
  }

  render() {
    return /*#__PURE__*/React.createElement("div", {
      ref: ref => {
        this.refElement = ref;
        const animationPreviewCanvas = getAnimationPreviewCanvas();
        if (!animationPreviewCanvas) return;

        if (ref) {
          animationPreviewCanvas.attach(ref);
        } else {
          animationPreviewCanvas.detach();
        }
      }
    });
  }

}